exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doc-field-container[data-v-390955aa]{width:100%;height:100%;position:relative}.delete-button[data-v-390955aa]{position:absolute;top:0;right:0;z-index:1}.doc-field-container>[data-v-390955aa]:not(.delete-button){width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-390955aa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/documents/DocumentField.vue
// module id = 1044
// module chunks = 2